import React, { createContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const UserStoryFlowDataContext = createContext(null);
export const UserStoryLoaderStateContext = createContext(null);

const UserStoryMainPage = () => {
  const [userStory, setUserStory] = useState({});
  const [evaluationSummary, setEvaluationSummary] = useState([]);
  const [refinedUserStory, setRefinedUserStory] = useState({});
  const [useCase, setUseCase] = useState({});

  const [userStoryLoaderState, setUserStoryLoaderState] = useState(null);

  const breadCrumbs = [
    {
      title: "Input Details",
      status: Object.keys(userStory).length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Evaluate User Story",
      status:
        Object.keys(evaluationSummary).length > 0
          ? "Completed"
          : Object.keys(userStory).length > 0 &&
            userStoryLoaderState === "Evaluation Summary"
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Refine User Story",
      status:
        Object.keys(refinedUserStory).length > 0
          ? "Completed"
          : Object.keys(evaluationSummary).length > 0 &&
            userStoryLoaderState === "Refined User Story"
          ? "In Progress"
          : "Not Started",
    },
    // {
    //   title: "Generate Use Cases",
    //   status:
    //     Object.keys(useCase).length > 0
    //       ? "Completed"
    //       : Object.keys(refinedUserStory).length > 0 &&
    //       userStoryLoaderState === "Use Case"
    //       ? "In Progress"
    //       : "Not Started",
    // },
  ];
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        minWidth: 0, // Important: allows flex items to shrink below content size
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch", // Changed from center to stretch
        flexGrow: 1,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          width: "100%",
          minWidth: 0, // Important: allows shrinking
          overflow: "hidden",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Fixed breadcrumb */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%",
            minWidth: 0,
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            overflow: "hidden",
            flexShrink: 0, // Prevent breadcrumb from shrinking
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
          sx={{
              height: "56px",
              width: "100%",
              minWidth: 0,
            }}
          />
        </Box>

        {/* Scrollable Content */}

        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "stretch", // Changed from center to stretch
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            minWidth: 0, // Important: allows shrinking
            minHeight: "80vh",
            height: "80vh",
            flexGrow: 1,
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",
            scrollbarColor: "#888 transparent",
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          {/* Container for Page Content */}
          <Container
            disableGutters
            maxWidth={false}
            sx={{
              width: "100%",
              boxSizing: "border-box",
              padding: {
                xs: "8px",
                sm: "16px",
                md: "24px",
                lg: "32px",
              },
            }}
          >
            <UserStoryLoaderStateContext.Provider
              value={{ userStoryLoaderState, setUserStoryLoaderState }}
            >
              <UserStoryFlowDataContext.Provider
                value={{
                  userStory,
                  setUserStory,
                  evaluationSummary,
                  setEvaluationSummary,
                  refinedUserStory,
                  setRefinedUserStory,
                  useCase,
                  setUseCase,
                }}
              >
                <Box sx={{ width: "100%" }}>
                  <Outlet />
                </Box>
              </UserStoryFlowDataContext.Provider>
            </UserStoryLoaderStateContext.Provider>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
export default UserStoryMainPage;
